import { render } from "./faw.vue?vue&type=template&id=3559f808&scoped=true"
import script from "./faw.vue?vue&type=script&lang=js"
export * from "./faw.vue?vue&type=script&lang=js"

import "./faw.vue?vue&type=style&index=0&id=3559f808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3559f808"]])

export default __exports__